export const sellPageMessages = {
	sellButtonLabel: {
		id: 'sellButtonLabel',
		defaultMessage: 'Send message',
	},
	sellSubmitSuccessTitle: {
		id: 'sellSubmitSuccessTitle',
		defaultMessage: 'Thanks for reaching out!',
	},
	sellSubmitSuccessDescription: {
		id: 'sellSubmitSuccessDescription',
		defaultMessage: 'You should hear back from us within a few business days.',
	},
};
